import { render, staticRenderFns } from "./siderList.vue?vue&type=template&id=6782ef89&scoped=true&"
import script from "./siderList.vue?vue&type=script&lang=js&"
export * from "./siderList.vue?vue&type=script&lang=js&"
import style0 from "./siderList.vue?vue&type=style&index=0&id=6782ef89&lang=scss&scoped=true&"
import style1 from "./siderList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6782ef89",
  null
  
)

component.options.__file = "siderList.vue"
export default component.exports